export const unsavedChangesUtil = {
  func: () => alert('😭')
};
